<template>
    <div class="app">
        <jycheader :navIndex="5"></jycheader>
        <div class="join_box">
            <!-- <div class="join_header"></div> -->
            <img
                style="width:90%;height:auto;margin:0 5%"
                src="../../assets/image/img/NewRegister/jiamengbanner.png"
            />
            <!-- 加盟政策 -->
            <join-policy></join-policy>
            <!-- 加盟申请 -->
            <join-application></join-application>
        </div>
        <el-backtop :bottom="100">
            <div style="{
		        height: 100%;
		        width: 100%;
		        border-radius: 100px;
		        background-color: #f2f5f6;
		        box-shadow: 0 0 6px rgba(0,0,0, .12);
		        text-align: center;
		        line-height: 40px;
		        color: #569516;
		      }">
                <i class="el-icon-upload2"></i>
            </div>
        </el-backtop>
        <jycbottom></jycbottom>
        <!-- <div v-if="is_wximg" class="index-img-pos-left">
            <div><img @click="closeWxClick" style="width:25px;height:auto;cursor:pointer;margin:0 0 10px 0" src="../../assets/image/iocn/close.png"/></div>
            <img
                style="width:100%;height:auto"
                src="../../assets/image/iocn/wxxcx.png"
            />
        </div> -->
    </div>
</template>

<script>
    import jycheader from "../header.vue"
    import jycbottom from "../bottom.vue"
    import joinpolicy from "../joinComponents/joinPolicy.vue"
    import joinapplication from "../joinComponents/joinApplication.vue"
    export default
    {
        data()
        {
            return {
                is_wximg: false,
            }
        },
        components:
        {
            jycheader,
            jycbottom,
            'join-policy': joinpolicy,
            'join-application': joinapplication
        },
        created() {
            window.scroll(0, 0)
            this.is_wximg = true
        },
        methods: {
            closeWxClick() {
                this.is_wximg = false
            },
        }
    }
</script>

<style scoped="scoped">
    .join_box {
        width: 100%;
        height: 100%;
    }

    /* .join_header {
        width: 100%;
        height: 48.8125rem;
        background-image: url(../../assets/image/img/NewRegister/jiamengbanner.png);
        background-size: cover;
        background-position: center;
    } */

    .join_poli {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        background-color: #FFFFFF;
    }

    .join_polis {
        width: 75rem;
        height: 24.6875rem;
    }

    .join_polis h4 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: normal;
        color: #999999;
        margin-top: 1rem;
    }

    .join_poliscent {
        display: flex;
        justify-content: space-between;
        margin-top: 1rem;
    }

    .join_poliscentA {
        width: 24.1875rem;
        height: 11.3125rem;
        background: #F5F5F5;
    }

    .join_poliscentAimg {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -491px -672px;
        width: 387px;
        height: 3px;
    }

    .join_poliscentA {}

    .join_poliscentA h3 {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        border-bottom: 1px solid #BFBFBF;
        height: 2rem;
        padding: 1rem;
    }

    .join_poliscentA p {
        width: 20.625rem;
        height: 3.75rem;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        text-indent: 2em;
        margin: 1rem 1.5rem;
    }

    .join_tabl {
        width: 100%;
        height: 45.1875rem;
        background: #EFEFEF;
    }

    .join_polistop {
        width: 14.375rem;
        height: 3.75rem;
        text-align: center;
        margin-left: 30rem;
    }

    .join_polistop h2 {
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: normal;
        color: #000000;
        border-bottom: 1px solid #BFBFBF;
        height: 3rem;
    }

    .join_polistop P {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #999999;
        background-color: #FFFFFF;
        width: 11rem;
        position: absolute;
        margin: -0.8rem 1.8rem;
    }

    .join__tabltops {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .join__tabltop {
        width: 14.375rem;
        height: 3.75rem;
        text-align: center;
        margin-top: 2.5rem;
    }

    .join__tabltop h2 {
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: normal;
        color: #000000;
        border-bottom: 1px solid #BFBFBF;
        height: 3rem;
    }

    .join__tabltop P {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #999999;
        background-color: #EFEFEF;
        width: 11rem;
        position: absolute;
        margin: -0.8rem 1.8rem;
    }

    .join_tablh {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .join_tablhs {
        width: 75rem;
    }

    .join_tablhs p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
    }

    .join_tablhs span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
    }

    .join_cent {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .join_cents {
        width: 75rem;
        height: 28.6875rem;
        background: #FFFFFF;

    }

    .join_centsname {
        width: 13.75rem;
        display: flex;
        margin: 2rem 2rem;
    }

    .join_centsnameA {
        width: 5.5rem;
        height: 2rem;
        border: 1px solid #069338;
        border-radius: 16px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #069338;
        line-height: 30px;
        text-align: center;
    }

    .join_centsnameB {
        width: 5.5rem;
        height: 2rem;
        border: 1px solid #b6b6b6;
        opacity: 0.5;
        border-radius: 16px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #8a8a8a;
        line-height: 30px;
        text-align: center;
        margin-left: 1rem;
    }

    .join_centinput {
        width: 71.25rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-left: 2rem;
    }

    .join_centinputA {
        width: 34.625rem;
        height: 3.375rem;
        background: #F5F5F5;
        margin-top: 0.7rem;
    }

    .join_centinputA p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        margin-left: 1rem;

    }

    .join_centinputA input {
        width: 27rem;
        height: 3.375rem;
        background: #F5F5F5;
        border: none;
        outline: none;
    }

    .join_botm {
        width: 71.125rem;
        height: 8.25rem;
        background: #F5F5F5;
        margin: 1rem 2rem;
    }

    .join_botm input {
        width: 71.125rem;
        background: #F5F5F5;
        outline: none;
        border: none;

    }

    .join_btn {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .join_btn button {
        width: 71.0625rem;
        height: 3.25rem;
        background: #069338;
        border: none;
        outline: none;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }
</style>